import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import EllipseDot from '../../../../assets/images/ellipse-dot';
import { Flex } from '@magnetic/flex';
import styled from 'styled-components';
import useTime from '../hook/time';
const Container = styled(Flex) ``;
const Text = styled.span `
  font-family: 'Sora';
  font-weight: 400;
`;
const DayDateText = styled(Text) `
  font-size: 0.729vw;
  letter-spacing: 0em;
  line-height: 2.176vh;
  max-width: 100%;
  overflow-wrap: anywhere;
  text-align: center;
`;
const TimeText = styled(Text) `
  font-size: 1.042vw;
  line-height: 1.759vh;
  color: #00bceb;
`;
const Time = () => {
    const { time, dateLabel } = useTime();
    return (_jsxs(Container, Object.assign({ direction: "verticle", justify: "center", align: "center" }, { children: [_jsx(DayDateText, Object.assign({ title: dateLabel }, { children: dateLabel })), _jsxs(Flex, Object.assign({ direction: "horizontal", align: "center" }, { children: [_jsx(Flex, Object.assign({ style: { marginTop: '8px' } }, { children: _jsx(EllipseDot, {}) })), _jsx(TimeText, { children: time })] }))] })));
};
export default Time;
